export const SET_DATA = 'PAGINATOR_SET_DATA';
export const UPDATE_ITEM = 'PAGINATOR_UPDATE_ITEM';
export const ADD_ITEM = 'PAGINATOR_ADD_ITEM';
export const REMOVE_ITEM = 'PAGINATOR_REMOVE_ITEM';
export const SET_SELECTION = 'PAGINATOR_SET_SELECTION';
export const TOGGLE_SELECTION = 'PAGINATOR_TOGGLE_SELECTION';
export const CLEAR_SELECTION = 'PAGINATOR_CLEAR_SELECTION';
export const REMOVE_FILTER_SELECTION = 'PAGINATOR_REMOVE_FILTER_SELECTION';
export const SET_BEGINNING = 'PAGINATOR_SET_BEGINNING';
export const SET_SORT = 'PAGINATOR_SET_SORT';
export const SET_SEARCH_TERM = 'PAGINATOR_SET_SEARCH_TERM';
export const SET_TOTAL_COUNT = 'PAGINATOR_SET_TOTAL_COUNT';
export const SHOW_MESSAGE = 'PAGINATOR_SHOW_MESSAGE';
export const FADE_MESSAGE = 'PAGINATOR_FADE_MESSAGE';
export const HIDE_MESSAGE = 'PAGINATOR_HIDE_MESSAGE';

export function setData(data, elementId) {
    return {
        type: SET_DATA,
        elementId,
        payload: data,
    };
}

export function updateItem(data, elementId) {
    return {
        type: UPDATE_ITEM,
        elementId,
        payload: data,
    };
}

export function addItem(data, pageSize, elementId) {
    return {
        type: ADD_ITEM,
        elementId,
        payload: data,
        pageSize,
    };
}

export function removeItem(id, elementId) {
    return {
        type: REMOVE_ITEM,
        elementId,
        payload: id,
    };
}

export function setSelection(items, elementId) {
    return {
        type: SET_SELECTION,
        elementId,
        payload: items,
    };
}

export function toggleSelection(item, elementId) {
    return {
        type: TOGGLE_SELECTION,
        elementId,
        payload: item,
    };
}

export function clearSelection(elementId) {
    return {
        type: CLEAR_SELECTION,
        elementId,
    };
}

export function removeFilterSelection(filterIndex, id) {
    return {
        type: REMOVE_FILTER_SELECTION,
        filterIndex,
        id,
    };
}

export function setSort(sort, elementId) {
    return {
        type: SET_SORT,
        elementId,
        payload: sort,
    };
}

export function setBeginning(beginning, elementId) {
    return {
        type: SET_BEGINNING,
        elementId,
        payload: beginning,
    };
}

export function refresh(elementId) {
    return {
        type: SET_BEGINNING,
        elementId,
        payload: null,
    };
}

export function setTotalCount(totalCount, elementId) {
    return {
        type: SET_TOTAL_COUNT,
        elementId,
        payload: totalCount,
    };
}

export function setSearchTerm(searchTerm, elementId) {
    return {
        type: SET_SEARCH_TERM,
        elementId,
        payload: searchTerm,
    };
}

export function showMessage(message, elementId) {
    return {
        type: SHOW_MESSAGE,
        elementId,
        payload: message instanceof Object ? {...message, type: message.type || 'info'} : {message, type: 'info'},
    };
}

export function hideMessage(message, elementId) {
    return dispatch => {
        dispatch({
            type: FADE_MESSAGE,
            elementId,
            payload: message,
        });
        setTimeout(() => dispatch({
            type: HIDE_MESSAGE,
            elementId,
            payload: message,
        }), 1000);
    };
}
